// GPT-Live の受信音声を鳴らす <audio> を 1 つだけ持つ (spec 2026-09-14 §3.1 / §3.10)。
//
// **事前チェックと本編の 2 セッションで同じ要素を使い回す** — iOS (WebKit) の再生の許可は
// ユーザー操作の文脈でしか得られず、画面ごとに要素を作ると、タップなしで始まる本編の要素は
// 許可を持たない。マイク許可のタップで unlockLiveAudio() を呼んでおく (最初の await より前)。
//
// 作れない環境 (jsdom の一部 / 非ブラウザ) では null を返し、呼び出し側は黙って続ける (原則 5)。
// cascade の ttsPlayer は触らない (無音の WAV もここで別に持つ)。

// 8kHz mono 16bit の 1 サンプルだけの WAV。unlock を同期で済ませるため data URI にしてある
const SILENT_WAV =
  "data:audio/wav;base64,UklGRiYAAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YQIAAAAAAA==";

let el: HTMLAudioElement | null = null;

export function liveAudioElement(): HTMLAudioElement | null {
  if (el) return el;
  const Ctor = (globalThis as { Audio?: typeof Audio }).Audio;
  if (!Ctor) return null;
  try {
    const a = new Ctor();
    a.autoplay = true;
    a.setAttribute("playsinline", "");
    el = a;
  } catch {
    el = null;
  }
  return el;
}

/** ユーザー操作の文脈で一度鳴らし、以後この要素で鳴らせるようにする */
export function unlockLiveAudio(): void {
  const a = liveAudioElement();
  if (!a) return;
  try {
    // 受信中の流れがあるときは上書きしない (2 回目以降のタップ)
    if (!a.srcObject) a.src = SILENT_WAV;
    const p = a.play();
    if (p && typeof p.catch === "function") p.catch(() => undefined);
  } catch {
    // 鳴らせなくても本編は続ける
  }
}

/** テスト用: 持っている要素を捨てる */
export function resetLiveAudioForTest(): void {
  el = null;
}
